import React from 'react';

import ImageSlider from '../common/ImageSlider';
import RightHandImage from '../common/RightHandImage';
import GalleryModal from './GalleryModal';
import GalleryToolbar from './GalleryToolbar';
import NoImage from '../common/NoImage';
import MyCarsSaveIcon from './MyCarsSaveIcon';
import useWiapiVehicleMedia from '../../hooks/useWiapiVehicleMedia';
import {
	GalleryProvider,
	useGalleryContext
} from '../../contexts/GalleryContext';

const GalleryContainerInner = () => {
	const { state, actions, meta } = useGalleryContext();
	const { openModal, carouselIndex, totalImages } = state;
	const { setCarouselIndex, setActiveTab, onOpenModal } = actions;
	const {
		primarySliderRef,
		isDesktop,
		galleryToolbarPlacement,
		imgTitle,
		prefs
	} = meta;

	const {
		imgThumbStyle,
		widgetClasses,
		galleryToolbarStyle,
		showMyCarsSave
	} = prefs;

	const isMobile = !isDesktop;
	const isShowSaveBtn = showMyCarsSave === 'true';
	const isOverlayMode = galleryToolbarStyle === 'none';

	// Show Mobile Save Icon in top-right corner when not handled by toolbar
	const showMobileSaveIcon =
		isMobile &&
		isShowSaveBtn &&
		!(
			galleryToolbarPlacement === 'top' &&
			isOverlayMode &&
			imgThumbStyle === 'horizontal'
		);

	// Apply max-width constraint for full width gallery layout on desktop

	const classNames =
		widgetClasses.includes('full-width-gallery') &&
		isDesktop &&
		(imgThumbStyle === 'horizontal' || totalImages === 1)
			? 'max-w-85vh'
			: '';

	const { widgetElement } = useWiapiVehicleMedia({
		carouselIndex,
		setCarouselIndex,
		openModal
	});

	if (totalImages === 0) {
		return <NoImage />;
	}

	return (
		<div
			className={`position-relative ${
				!isDesktop ? 'mx-n4' : ''
			} ${classNames}`}
			data-location="vehicle-media-container"
			data-testid="gallery-container"
		>
			<div>
				{galleryToolbarPlacement === 'top' && <GalleryToolbar />}
				{/* Mobile Save Icon - Top Right corner */}
				{showMobileSaveIcon && (
					<div
						className="save-icon-mobile position-absolute absolute-right mx-4 mt-4"
						data-testid="save-icon-mobile"
					>
						<MyCarsSaveIcon />
					</div>
				)}
				<div className="overflow-auto">
					{imgThumbStyle === 'horizontal' ? (
						<ImageSlider
							sliderRef={primarySliderRef}
							widgetElement={widgetElement}
						/>
					) : (
						<RightHandImage
							onOpenModal={onOpenModal}
							setCarouselIndex={setCarouselIndex}
							setActiveToolbar={setActiveTab}
							imgTitle={imgTitle}
						/>
					)}
				</div>
				{galleryToolbarPlacement === 'bottom' && <GalleryToolbar />}
			</div>
			<GalleryModal />
		</div>
	);
};

const GalleryContainer = () => (
	<GalleryProvider>
		<GalleryContainerInner />
	</GalleryProvider>
);

export default GalleryContainer;
